import {createMuiTheme} from '@material-ui/core/styles';


class ThemaCustomized {

    static system() {

        return createMuiTheme({
            palette: {
                type: 'light',
                primary: {
                    main: '#' + process.env.REACT_APP_PRIMARY_COLOR
                },
                secondary: {
                    main: '#' + process.env.REACT_APP_SECONDARY_COLOR,
                },
            },
            overrides: {
                MuiTooltip: {
                    tooltip: {
                        fontSize: '1em',
                        backgroundColor: '#e3e3e3',
                        color: '#' + process.env.REACT_APP_PRIMARY_COLOR,
                    }
                }
            },
        });
    }
}

export default ThemaCustomized